import { AppStatusIncidentInput } from '@src/main/modules/app_status/domain/appStatusIncident.model';
import {
  AppStatusIncidentRepository,
  AppStatusIncidentSearch,
} from '@src/main/modules/app_status/domain/appStatusIncident.repository';

export const findAppStatusIncidents = (
  repository: AppStatusIncidentRepository,
  criteria: AppStatusIncidentSearch,
) => repository.findAll(criteria);

export const createAppStatusIncident = (
  repository: AppStatusIncidentRepository,
  input: AppStatusIncidentInput,
) => repository.create(input);

export const updateAppStatusIncident = (
  repository: AppStatusIncidentRepository,
  id: string,
  input: AppStatusIncidentInput,
) => repository.update(id, input);

export const deleteAppStatusIncident = (repository: AppStatusIncidentRepository, id: string) =>
  repository.delete(id);
